import tokens from './artifacts/token-names';

function token(path, fallback) {
  if (process.env.NODE_ENV !== 'production' && !tokens[path]) {
    throw new Error("Unknown token at path: ".concat(path));
  }

  var token = tokens[path];
  var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
  return tokenCall;
}

export default token;